import { useTranslation } from 'react-i18next';
import { useDialoger } from '~/modules/common/dialoger/use-dialoger';
import type { OnboardingStates } from '~/modules/home/onboarding/steps';
import { Button } from '~/modules/ui/button';

interface SkipOrganizationProps {
  setOnboardingState: (newState: Exclude<OnboardingStates, 'start'>) => void;
}

export function SkipOrganization({ setOnboardingState }: SkipOrganizationProps) {
  const { t } = useTranslation();

  const removeDialog = useDialoger((state) => state.remove);

  const onDelete = () => {
    removeDialog('skip-org-creation');
    setOnboardingState('completed');
  };

  const onCancel = () => {
    removeDialog('skip-org-creation');
  };

  return (
    <div className="flex gap-2 sm:flex-row">
      <Button type="submit" variant="destructive" onClick={onDelete}>
        {t('c:skip')}
      </Button>
      <Button type="reset" variant="secondary" onClick={onCancel}>
        {t('c:cancel')}
      </Button>
    </div>
  );
}
